import * as React from "react";
import {
	Breadcrumb,
	BreadcrumbItem,
	BreadcrumbList,
	BreadcrumbSeparator,
} from "shadcn-ui";

import { cn } from "@/lib/utils";
import type { NavItem } from "@/types/nav";
import { useLocation, useSearch } from "@tanstack/react-router";

interface MainNavProps {
	items?: NavItem[];
}

export const isCuid = (value: string) => /^c[a-z0-9]{24}$/.test(value);

export function MainNav() {
	const pathname = useLocation();
	const searchParams = useSearch({
		from: "/_app",
	}) as { name?: string; from?: string; to?: string };

	const getPath = React.useMemo(() => {
		const path = pathname.href
			.replace("/", "")
			.split("/")
			.map((i) => i.replaceAll("-", " "));

		const set = new Set([...path]);

		if (searchParams?.name) {
			set.delete(path[path.length - 1] ?? "");
			set.add(searchParams.name ?? "");

			const pathArray = Array.from(set);

			return pathArray;
		}

		if (searchParams?.from && searchParams?.to) {
			const current = path[path.length - 1] ?? "";
			set.delete(current);

			const title = current.split("?")?.[0];

			if (title) {
				set.add(title);
			}

			const pathArray = Array.from(set);

			return pathArray;
		}

		if (Object.keys(searchParams).length !== 0) {
			const current = path[path.length - 1] ?? "";
			set.delete(current);

			const title = current.split("?")?.[0];

			if (title) {
				set.add(title);
			}

			const pathArray = Array.from(set);

			return pathArray;
		}

		const pathArray = Array.from(set);

		return pathArray;
	}, [pathname, searchParams]);

	return (
		<div className="flex gap-2 md:gap-4 items-center">
			<Breadcrumb>
				<BreadcrumbList className="">
					{getPath.map((i, index) => (
						<React.Fragment key={i}>
							<BreadcrumbItem
								key={i}
								className={cn({
									"pointer-events-none": index === getPath.length - 1,
									"hidden md:block": index !== getPath.length - 1,
								})}
							>
								{/* <Link href="/" className="flex items-center space-x-2"> */}
								<span className="capitalize">{i}</span>
								{/* </Link> */}
							</BreadcrumbItem>

							{getPath[getPath.length - 1] !== i && (
								<BreadcrumbSeparator className="hidden md:block" />
							)}
						</React.Fragment>
					))}
				</BreadcrumbList>
			</Breadcrumb>
		</div>
	);
}

const Separator = React.memo(() => {
	return (
		<BreadcrumbSeparator className="mx-2">
			<span className="text-2xl text-gray-300 dark:text-slate-500 ">/</span>
		</BreadcrumbSeparator>
	);
});

// {getPathname().map((i, index) => {
//   if (
//     typeof i === "string" &&
//     isCuid(i) &&
//     searchParams.get("name")
//   ) {
//     return (
//       <React.Fragment key={i}>
//         <Separator />
//         <Link
//           href={
//             i.includes("_")
//               ? isCuid(i.split("_")[1])
//                 ? ""
//                 : `/${i}`
//               : isCuid(i)
//                 ? ""
//                 : `/${i}`
//           }
//         >
//           <BreadcrumbItem>
//             {searchParams.get("name") || i}
//           </BreadcrumbItem>
//         </Link>
//       </React.Fragment>
//     );
//   }

//   if (
//     typeof i === "string" &&
//     i.includes("_") &&
//     searchParams.get("name")
//   ) {
//     return (
//       <React.Fragment key={i}>
//         <Separator />
//         <Link href={i.includes("_") ? "" : `/${i}`}>
//           <BreadcrumbItem>
//             {searchParams.get("name") || i}
//           </BreadcrumbItem>
//         </Link>
//       </React.Fragment>
//     );
//   }

//   if (typeof i !== "string") {
//     if (i.child) {
//       return (
//         <React.Fragment key={`${i.id}.${index}`}>
//           {/* <Separator /> */}
//           <BreadcrumbItem>
//             <DropdownMenu>
//               <DropdownMenuTrigger className="flex items-center gap-1">
//                 {i.name}
//                 <span className="sr-only">Toggle menu</span>
//               </DropdownMenuTrigger>
//               <DropdownMenuContent
//                 align="start"
//                 className="p-2 w-48"
//                 forceMount
//                 sticky="always"
//               >
//                 {i.child.map((i) => (
//                   <Link
//                     href={i.href}
//                     key={i.id}
//                     className="cursor-pointer"
//                   >
//                     <DropdownMenuItem>{i.name}</DropdownMenuItem>
//                   </Link>
//                 ))}
//               </DropdownMenuContent>
//             </DropdownMenu>
//           </BreadcrumbItem>
//         </React.Fragment>
//       );
//     }
//     return (
//       <React.Fragment key={`${i.id}.${index}`}>
//         <Separator />
//         <Link href={i.href}>
//           <BreadcrumbItem>{i.name}</BreadcrumbItem>
//         </Link>
//       </React.Fragment>
//     );
//   }
//   return (
//     <React.Fragment key={`${i}.${i}`}>
//       <Separator />
//       <BreadcrumbItem>
//         <BreadcrumbLink>{i}</BreadcrumbLink>
//       </BreadcrumbItem>
//     </React.Fragment>
//   );
// })}
